<mat-card class="cardWithShadow card-profile">
  <mat-card-content class="p-y-24 text-center">
    <mat-card-title>{{ "technicians.technicians" | translate }}</mat-card-title>
    <mat-card-subtitle class="f-s-14">{{technician?.name}} {{technician?.lastname}}</mat-card-subtitle>
    <div class="text-center m-t-24">
      @if (qrcode){
        <img [src]="qrcode" class="rounded-1 img-fluid w-70">

        <div class="row justify-content-center p-y-12">
          <button mat-flat-button type="button" (click)="sendEmail(technician)" class="justify-content-center f-s-14 f-w-500 btn mb-1 btn-rounded btn-primary d-flex align-items-center gap-4">
            <div class="d-flex align-items-center f-s-14 f-w-500 btn mb-1 btn-rounded btn-primary gap-4">
              <i-tabler name="send-2" class="icon-18 d-flex"></i-tabler>
              {{ 'technicians.send' | translate }}
            </div>
          </button>
          <button mat-flat-button type="button" (click)="downloadQrcode()" class="justify-content-center f-s-14 f-w-500 btn mb-1 btn-rounded btn-primary d-flex align-items-center gap-4 m-l-6">
            <div class="d-flex align-items-center f-s-14 f-w-500 btn mb-1 btn-rounded btn-primary gap-4">
              <i-tabler name="download" class="icon-18 d-flex"></i-tabler>
              {{ 'technicians.download' | translate }}
            </div>
          </button>
        </div>
      }
    </div>
  </mat-card-content>
</mat-card>
